module.exports = __webpack_public_path__ + "img/half-iphone-x.94f88f62.svg";